import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Download, MessageSquare } from "lucide-react";
import { MOCK_ORDERS } from "../../data/mock";
import { StatusBadge } from "./CustomerHome";

const TABS = ["All", "Active", "Completed", "Cancelled"];

export default function CustomerOrders() {
  const [tab, setTab] = useState("All");
  const filtered = MOCK_ORDERS.filter((o) => {
    if (tab === "All") return true;
    if (tab === "Active") return o.status !== "delivered" && o.status !== "cancelled";
    if (tab === "Completed") return o.status === "delivered";
    if (tab === "Cancelled") return o.status === "cancelled";
    return true;
  });

  return (
    <div data-testid="customer-orders">
      <h1 className="font-display text-3xl font-bold">My Orders</h1>
      <div className="mt-3 flex flex-wrap gap-2">
        {TABS.map((t) => (
          <button key={t} onClick={() => setTab(t)} className={`rounded-full border px-3 py-1 text-xs font-semibold ${tab === t ? "border-neutral-900 bg-neutral-950 text-white" : "border-neutral-200 hover:border-neutral-900"}`} data-testid={`orders-tab-${t.toLowerCase()}`}>{t}</button>
        ))}
      </div>

      <div className="mt-4 space-y-3">
        {filtered.map((o) => (
          <div key={o.id} className="rounded-lg border border-neutral-200 bg-white p-4" data-testid={`order-${o.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <div className="font-mono text-xs text-neutral-500">{o.id} · {o.placed}</div>
                <div className="mt-1 font-display text-lg font-bold">{o.product}</div>
                <div className="text-xs text-neutral-500">{o.customer} · {o.location}</div>
              </div>
              <div className="text-right">
                <div className="font-mono text-lg font-bold">₹{o.amount.toLocaleString("en-IN")}</div>
                <div className="mt-1"><StatusBadge status={o.status} /></div>
              </div>
            </div>
            <div className="mt-3 flex flex-wrap gap-2">
              <Link to="/customer/track" className="rounded-md border border-neutral-300 px-3 py-1.5 text-xs font-semibold hover:border-neutral-900" data-testid={`order-track-${o.id}`}>Track</Link>
              <button onClick={() => toast.success(`Invoice ${o.id}.pdf downloaded`)} className="inline-flex items-center gap-1 rounded-md border border-neutral-300 px-3 py-1.5 text-xs font-semibold hover:border-neutral-900" data-testid={`order-invoice-${o.id}`}><Download size={12} /> Invoice</button>
              <button onClick={() => toast.success("Reorder started")} className="rounded-md border border-neutral-300 px-3 py-1.5 text-xs font-semibold hover:border-neutral-900" data-testid={`order-reorder-${o.id}`}>Reorder</button>
              <a href="https://wa.me/919899747172" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 rounded-md border border-neutral-300 px-3 py-1.5 text-xs font-semibold hover:border-neutral-900" data-testid={`order-chat-${o.id}`}><MessageSquare size={12} /> Chat vendor</a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
